import commonApi from './CommonApi.js';

var qs = require('querystring');

export default {
	getAll: async (parameter) => {
		return await commonApi().get('/v1/tbt/article152Notifications/getAll',
				{
					params: parameter,
					paramsSerializer: (params) => {
						return qs.stringify(params);
					}
				})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getAzure: async (parameter) => {
		return await commonApi().get('/v1/tbt/article152Notifications/getAzure',
			{
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error)
				return {};
			});
	},
	getById: async (parameters) => {
		return await commonApi().get('/v1/tbt/article152Notifications/getById', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	create: async (viewModel) => {

		return await commonApi().post('/v1/tbt/article152Notifications?language=' + window.currentLanguageEnum, viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	edit: async (viewModel) => {
		return await commonApi().put('/v1/tbt/article152Notifications?language=' + window.currentLanguageEnum, viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	delete: async (parameters) => {
		return await commonApi().delete('/v1/tbt/article152Notifications', { params: parameters })
			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	submit: async (viewModel) => {
		return await commonApi().post('/v1/tbt/article152Notifications/submit?language=' + window.currentLanguageEnum, viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
}